<template>
  <div>
    <br />
    <b-navbar
      :fixed-top="$isMobile()"
      :transparent="true"
      wrapper-class="container"
    >
      <template #brand>
        <b-navbar-item href="https://biddingmate.com.au/">
          <img src="~@/common/assets/bmi-white.svg" alt="Bidding mate" />
        </b-navbar-item>
      </template>
      <template v-if="sharedState.authn" #end>
        <b-navbar-item href="https://my.biddingmate.com.au/markets">
          Markets
        </b-navbar-item>
        <b-navbar-item
          href="https://my.biddingmate.com.au/mysales"
          v-if="hasAdminRole"
        >
          My Sales
        </b-navbar-item>
        <b-navbar-item href="https://my.biddingmate.com.au/myprofile">
          Account
        </b-navbar-item>
        <b-navbar-item @click="login"> Logout </b-navbar-item>
      </template>
      <template v-else #end>
        <b-navbar-item href="https://my.biddingmate.com.au/markets">
          Markets
        </b-navbar-item>
        <b-navbar-item @click="login"> Login / Signup </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<style>
a {
  color: white;
}
a:hover {
  color: white;
  text-decoration: underline;
}
.control a:hover {
  text-decoration: none;
}
</style>

<style scoped>
a {
  color: gray;
}

.right {
  color: gray;
  text-align: right;
}
</style>

<script>
import { bus } from '../bus'
import { store } from '../store'

import Vue from 'vue'
import { Navbar } from 'buefy'
import VueMobileDetection from 'vue-mobile-detection'
Vue.use(Navbar)
Vue.use(VueMobileDetection)

export default {
  name: 'Navbar',
  components: {},
  data() {
    return {
      sharedState: store
    }
  },
  computed: {
    hasAdminRole() {
      if (!this.sharedState.permissionsAvailable) {
        return false
      }

      let hasAdmin = false
      this.sharedState.permissions.forEach(perm => {
        if (perm.roles.includes('admin')) {
          hasAdmin = true
        }
      })

      return hasAdmin
    }
  },
  methods: {
    navHome() {
      bus.$emit('home')
    },
    login() {
      bus.$emit('auth')
    }
  }
}
</script>
